import Highway from '@dogstudio/highway'
import modular from 'modujs'
import gsap from 'gsap'

import * as modules from './modules'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'

import { firstFireFoxCheck } from './utils/dom'
import { initPrefetch, refreshPrefetch } from './utils/prefetch'
import { handleAnchorScroll } from './utils/scroll'
import { classesInjection, rewriteLinks } from './utils/transitions'

const Modular = modular
const app = new Modular({
  modules
})

const DEFAULT_TEXT_COLOR = '#000000'
const DEFAULT_BG_COLOR = '#ffffff'

const isCommercePath = (pathname) => {
  return /\/(shop|cart|checkout|my-account|product-category)(\/|$)/i.test(pathname) ||
    /\/product\//i.test(pathname)
}

const applyPageColors = ({ immediate = false } = {}) => {
  const main = document.querySelector('main')
  const textColor = main?.dataset?.textColor || DEFAULT_TEXT_COLOR
  const bgColor = main?.dataset?.bgColor || DEFAULT_BG_COLOR

  gsap.to(document.body, {
    '--c': textColor,
    '--bg': bgColor,
    duration: immediate ? 0 : 0.9,
    ease: 'power2.inOut',
    overwrite: 'auto'
  })
}

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {
    handleAnchorScroll()
    rewriteLinks()
    refreshPrefetch()
    app.init(app)
    applyPageColors()
    return this
  }

  onLeaveCompleted () {
    app.destroy()
    return this
  }
}

const init = () => {
  firstFireFoxCheck()
  classesInjection()
  applyPageColors({ immediate: true })
  new Scroller()
  initPrefetch()

  // WooCommerce views: full page loads (AJAX cart fragments + checkout forms).
  if (document.body.classList.contains('no-highway')) {
    app.init(app)
    return
  }

  const wrapper = document.querySelector('[data-router-wrapper]')
  if (wrapper) {
    // Let the browser do a full navigation into commerce URLs (Highway stays off there).
    wrapper.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]')
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return
      try {
        const url = new URL(link.href, window.location.origin)
        if (url.origin !== window.location.origin) return
        if (isCommercePath(url.pathname)) {
          event.stopPropagation()
        }
      } catch (e) { /* ignore bad URLs */ }
    }, true)
  }

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: FadeTransition
    }
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true
      })
    }
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)
